import Link from "next/link";
import Image from "next/image";

import Heading from "./Heading";

const HypothesisDiscovery = () => (
  <>
    <Heading
      title="Automatic Hypothesis Discovery"
      subtitle="The Core of Daisho: Accelerated Problem Solving"
    />

    <blockquote className="p-8 bg-gray-300 rounded">
      <p className="text-xl mb-8">
        <span className="text-2xl">&ldquo;</span>At the end of the day, some
        machine learning projects succeed and some fail. What makes the
        difference? Easily the most important factor is the features
        (hypotheses) used.
        <span className="text-2xl">&rdquo;</span>
      </p>
      <cite>
        <p className="text-right">Pedro Domingos</p>
        <p className="text-right">A Few Useful Things About Machine Learning</p>
      </cite>
    </blockquote>
    <div className="flex flex-col-reverse md:flex-row p-4">
      <div className="mx-2 md:w-1/3 pb-4 md:pb-1">
        <p className="text-xl font-bold text-center">
          Accelerated Problem Solving: Feature Discovery in Daisho
        </p>
        <p className="pt-2">
          An analyst typically starts off with a list of hypotheses - from
          experience, literature, experts, etc. These are the pale boxes in the
          picture.
        </p>
        <p className="pt-2">
          However, the orange box is completely missed - and thats typically
          where the most interesting insights lie.
        </p>
        <p className="pt-2">
          The Daisho{" "}
          <span className="text-gray-600 italic font-bold">
            SignalFactory{" "}
            {/* <Link href="signal-factory-comic">
                      <a>&#8599;</a>
                    </Link> */}
          </span>{" "}
          generates 1000s of sophisticated business understandable hypotheses
          AUTOMATICALLY so that all four boxes are covered.{" "}
        </p>
        <p className="pt-2">
          The Daisho{" "}
          <span className="text-gray-600 italic font-bold">SignalFilter</span>{" "}
          then AUTOMATICALLY filters the most powerful features!
        </p>
      </div>
      <div className="mx-2 md:w-2/3 pb-4 md:pb-1">
        <Image
          src="/four-boxes.png"
          width={600}
          height={280}
          layout="responsive"
          alt="Uncovering the Unknown"
        />
      </div>
    </div>
    <div
      className="mx-auto sm:max-w-none flex flex-wrap justify-center mb-2"
      data-aos="zoom-y-out"
      data-aos-delay="150"
    >
      <Link href="/technology/signal-factory-comic" passHref>
        <a className="btn text-white bg-brand-600 hover:bg-brand-900 w-auto mb-2 mx-4 px-5 py-3 rounded">
          See the SignalFactory Comic
        </a>
      </Link>
      <Link href="/technology/signal-filter-comic" passHref>
        <a className="btn text-white bg-brand-600 hover:bg-brand-900 w-auto mb-2 mx-4 px-5 py-3 rounded">
          See the SignalFilter Comic
        </a>
      </Link>
    </div>
  </>
);

export default HypothesisDiscovery;
